import React, { useRef, useState, useMemo, useEffect } from 'react'
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import Typography from '@mui/material/Typography';
import { Grid } from '@mui/material';
import { getSelectedState } from "@progress/kendo-react-grid";
import { getter } from "@progress/kendo-react-common";
import { Operators, TextFilter, setExpandedState, setGroupIds } from "@progress/kendo-react-data-tools";
import getSetDataService from "../../../../shared/common-utilities/services/getSetDataService";
import { useSelector, useDispatch } from "react-redux";
import { drageItemsReducer } from '../../../../shared/ReduxStore/Reducers/dragReducer';
import Spinner from "../../common/Spinner/Spinner";
import sampletripData from "../../../../shared/common-utilities/utils/sampleTrips.json";
import Snackbar from '@mui/material/Snackbar';
import DataGridComponent from '../../common/DataGridComponent/DataGridComponent';


let service = getSetDataService();
const dataRelatedAction = ['Filter', 'View Columns', 'Settings', 'New Window'];
//#region SortData start


const Trip = (props) => {
    //#region Reference
    const tripGrid = useRef(null);
    //#endregion Reference

    //#region Hook Selctor
    const drageItems = useSelector(state => state.drag);
    const dispatch = useDispatch()
    let gridSelectedValues = {}
    //#endregion Hook Selctor

    let tripData = [...sampletripData];
    let availableTrip = useMemo(() => tripData.slice(), []);
    const splicedTrip = useMemo(() => availableTrip.splice(0, 25), []);
    const tempTripData = useMemo(() => splicedTrip);

    const tripGriddDtaItemKey = "id";
    const initialFilter = service.initialFilter;
    const tripGridColumnList = service.tripColumnList
    const tripGrididGetter = getter(tripGriddDtaItemKey);

    //#region States - Get set variables  
    const [tripGridDataState, setTripGridDataState] = React.useState({});
    const [tripGridFilterValues, setTripGridFilterValues] = React.useState(initialFilter);
    const [tripGridFilterFields, setTripGridFilterFields] = React.useState([]);
    const [tripGridSelectedState, setTripGridSelectedState] = React.useState({});
    const [tripGridPartialSelectedState, setTripGridPartialSelectedState] = React.useState({});
    const [collapsedState, setCollapsedState] = React.useState([]);
    const [isLoading, setIsLoading] = React.useState(true);
    const [isTrip, setIsTrip] = useState(true);
    const [loadedGridData, setLoadedGridData] = useState(tempTripData);
    const [tripGridData, setTripGridData] = React.useState(
        service.processWithGroups(
            tempTripData.map((item) => ({
                ...item,
                ["selected"]: tripGridSelectedState[tripGrididGetter(item)],
            })),
            tripGridDataState
        )
    );
    const tripFilterComponents = [];
    const [myGridData, setmyGridData] = React.useState([])
    const [loadSelectionValue, setloadSelectionValue] = useState(100);
    const [totalData, setTotalData] = useState(0);
    
    //#endregion States

    //#region Hooks  
    
    useEffect(() => {
        setTimeout(() => {
            setIsLoading(false)
        }, 1500)
        
        let tempFieldList = []
        tripGridColumnList.forEach(e => {
            const obj = {
                name: e.field,
                label: e.title,
                filter: TextFilter,
                operators: Operators.text,
            }
            tempFieldList.push(obj)
        })
        setTripGridFilterFields(tempFieldList)
    }, []);

    //#endregion Hooks


    //#region Methods

    // --- Callback methods START ---

    const tripGridOnDataStateChange = React.useCallback((e) => {
        const newDataState = service.processWithGroups(
            loadedGridData.map((item) => ({
                ...item,
                ["selected"]: tripGridSelectedState[tripGrididGetter(item)],
            })),
            e.dataState
        );
        setTripGridData(newDataState);

        setTripGridDataState(e.dataState);
        setTripGridFilterValues(e.dataState.filter || initialFilter);
    }, [loadedGridData]);

    const tripGridOnSelectionChange = React.useCallback(
        (event) => {
            const tempSelectedState = getSelectedState({
                event,
                selectedState: tripGridSelectedState,
                dataItemKey: tripGriddDtaItemKey,
            });

            setTripGridSelectedState(tempSelectedState);
        },
        [tripGridSelectedState, tripGridData.data]
    );

    const tripGridOnHeaderSelectionChange = React.useCallback((event) => {
        const checkboxElement = event.syntheticEvent.target;
        const checked = checkboxElement.checked;
        const tempSelectedState = {};
        event.dataItems.forEach((item) => {
            tempSelectedState[tripGrididGetter(item)] = checked;
        });
        setTripGridSelectedState(tempSelectedState);
    }, []);

    const tripGridOnRowClick = (rowData, ctrlPress = null) => {
        let tempstate = {}
        if (rowData != undefined) {
            if(ctrlPress) {
                tempstate = JSON.parse(JSON.stringify(tripGridPartialSelectedState));
            } else {
                tempstate = {};
            }
            if (!tempstate[rowData.id]) {
                tempstate['' + rowData.id] = true;
                setTripGridPartialSelectedState(tempstate);
            }
            else {
                console.log(tempstate, tripGridPartialSelectedState);
                delete tempstate[rowData.id];
                console.log(tempstate);
                setTripGridPartialSelectedState(tempstate)
            }
        };
    }

    const tripGridOnExpandChange = React.useCallback(
        (event) => {
            const item = event.dataItem;

            if (item.groupId) {
                const collapsedIds = !event.value
                    ? [...collapsedState, item.groupId]
                    : collapsedState.filter((groupId) => groupId !== item.groupId);
                setCollapsedState(collapsedIds);
            }
        },
        [collapsedState]
    );

    // --- Callback methods END ---

    const tripGridOnscroll = (event) => {
        const e = event.nativeEvent;
        if (
            e.target.scrollTop + 11 >=
            e.target.scrollHeight - e.target.clientHeight
        ) {
            setIsLoading(true)
            const moreData = availableTrip.splice(0, 12);
            if (moreData.length > 0) {
                setLoadedGridData((oldData) => {
                    const updatedData = oldData.concat(moreData);
                    if (moreData.length > 0) {
                        const tempGridData = service.processWithGroups(updatedData, { ...tripGridDataState });
                        setTripGridData(tempGridData);
                    }
                    return updatedData;
                });
            }
        }
        setTimeout(() => {
            setIsLoading(false)
        }, 500)
    };
   
    const disptachDragEvent = (e, target) => {
        const selectedIds = getSelectedValues();
        const selectedValues = service.getMembers(tripGridData.data).filter(e => selectedIds.includes('' + e.id))
        const obj = {
            source: 'Trip',
            destination: target,
            eventType: e,
            isTripGenerated: false,
            items: selectedValues
        }
        dispatch(drageItemsReducer(obj))
    }

    const tripGridOnDragStart = (rowData, e) => {

        const tempstate = JSON.parse(JSON.stringify(tripGridSelectedState))
        rowData.selected = !rowData.selected;
        tempstate['' + rowData.id] = true;
        setTripGridSelectedState(tempstate)
        const selectedIds = getSelectedValues(tempstate);
        const selectedValues = service.getMembers(tripGridData.data).filter(e => selectedIds.includes('' + e.id))
        const obj = {
            source: 'Trip',
            destination: null,
            eventType: 'drag',
            isTripGenerated: false,
            items: selectedValues
        }
        dispatch(drageItemsReducer(obj))
        disptachDragEvent('drag', null)

    }

    const tripGridOnDrop = (e) => {
        if (drageItems.source == "Trip") {
            if (e.target) {
                const selectedIds = getSelectedValues();
                const selectedValues = service.getMembers(tripGridData.data).filter(e => selectedIds.includes('' + e.id))
                const gridValues = service.getMembers(tripGridData.data).filter(e => !selectedIds.includes('' + e.id))

                const tempindex = selectedIds.filter(x => service.getMembers(tripGridData.data).findIndex(y => y.id == +x) < +e.target.parentElement.dataset.gridRowIndex).length
                const index = +e.target.parentElement.dataset.gridRowIndex - tempindex

                gridValues.splice(index, 0, ...selectedValues);
                setTripGridData(service.processWithGroups(gridValues, tripGridDataState))
            } else {
                let newDataFirst = [drageItems.items, ...service.getMembers(tripGridData.data)];
                tempTripData.push(drageItems.items)
                setTripGridData(service.processWithGroups(newDataFirst, { ...tripGridDataState }))

                const obj = {
                    source: 'PartialTrip',
                    destination: 'Trip',
                    eventType: drageItems.eventType,
                    items: drageItems.items
                }
                dispatch(drageItemsReducer(obj))
            }
        }
    };

    const setSelectedValue = (data) => {
        if (data) {
            let newData = data.map((item) => {
                if (item.items) {
                    return {
                        ...item,
                        items: setSelectedValue(item.items),
                    };
                } else {
                    return {
                        ...item,
                        ["selected"]: tripGridSelectedState[tripGrididGetter(item)],
                    };
                }
            });
            return newData;
        }
    };

    const newData = setExpandedState({
        data: setSelectedValue(tripGridData.data),
        collapsedIds: collapsedState,
    });

    // --- Common methods END ---


    //#endregion Methods


    //#region Not in use

    const getSelectedValues = (tempstate) => {
        if (tempstate) {
            return Object.keys(tempstate).filter((key) => tempstate[key] === true);
        } else {
            return Object.keys(tripGridSelectedState).filter((key) => tripGridSelectedState[key] === true);
        }
    };

    const childStateHandler = (value, flag) => {
        if(flag === 'gridSelectedState'){
          setTripGridSelectedState(value);
        } else if(flag === 'gridDataState'){
          setTripGridDataState(value);
        } else if(flag === 'gridData'){
          setTripGridData(value);
        } else if(flag === 'showGridHeader'){
          setIsTrip(value);
        }
    }

  
    const onLoadSelectionChange = (e) => {
        let value = e.value
        setloadSelectionValue(value)
        // sendApi(value)
      }
    //#endregion

    return (
        <>
            {isLoading ? (<Spinner />) : (<></>)}
            <Box component="main" sx={{ flexGrow: 1, p: 1, pb: 0, width: '99%' }} className="max-wgrid">

                {isTrip && <Box className="headBG" sx={{ px: 1, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <Typography variant="body2" color="secondary.contrastText" sx={{ fontWeight: 500 }}>Trip</Typography>
                </Box>}
                <Grid container sx={{ marginTop: 0 }}  >
                    <Grid item={true} xs component={Card} elevation={0} pl={0} sx={{ flexGrow: 1 }} className='grid-movement'>
                        <DataGridComponent
                            {...props}
                            gridRef={tripGrid}
                            gridFlagVal={"trip"} 
                            gridFlagValFor={"trip"}
                            gridStyle={{ maxHeight: 'calc(100%)', height: '100%', minHeight: '650px' }}
                            // gridAllData={tripData}
                            gridNewData={newData}
                            loadedGridData={loadedGridData}
                            tempGridData={tempTripData}
                            gridColumnList={tripGridColumnList}
                            gridTempColumnList={tripGridColumnList}
                            isItemVisible={true}
                            isShowGridHeader={isTrip} 
                            // gridDataState={tripGridDataState}
                            // grididGetter={tripGrididGetter}
                            griddDtaItemKey={tripGriddDtaItemKey} 
                            // gridOnDragStart={tripGridOnDragStart}
                            // gridOnDrop={tripGridOnDrop}
                            // gridOnExpandChange={tripGridOnExpandChange}
                            // gridOnscroll={tripGridOnscroll}
                            // gridOnRowClick={tripGridOnRowClick}
                            // gridCheckHeaderSelectionValue={checkHeaderSelectionValue}
                            // gridOnHeaderSelectionChange={tripGridOnHeaderSelectionChange}
                            // gridPartialSelectedState={tripGridPartialSelectedState}
                            // gridOnDataStateChange={tripGridOnDataStateChange}
                            // gridOnSelectionChange={tripGridOnSelectionChange}
                            // getSelectedValues={getSelectedValues}
                            // gridSelectedState={tripGridSelectedState}
                            sendDataToParent={childStateHandler}
                            gridDataAction={dataRelatedAction}
                            gridFilterComponents={tripFilterComponents}
                            onLoadSelectionChange={onLoadSelectionChange}
                            loadSelectionValue={loadSelectionValue}
                        />
                    </Grid>
                </Grid>
            </Box>
        </>
    )
};

export default Trip;
